import React, { useState, useEffect, useCallback } from 'react';
import api from '../../utils/api';
import { resolveUrl } from '../../utils/api';

function PostCard({ post, onDelete, onEditCaption, onDeleteComment, onEditComment }) {
  const [expanded, setExpanded] = useState(false);
  const [comments, setComments] = useState([]);
  const [commentsLoading, setCommentsLoading] = useState(false);
  const [editPos, setEditPos] = useState('');
  const [editingCaption, setEditingCaption] = useState(false);
  const [captionVal, setCaptionVal] = useState(post.caption);
  const [editCommentId, setEditCommentId] = useState(null);
  const [editCommentVal, setEditCommentVal] = useState('');

  const loadComments = async () => {
    if (comments.length && expanded) { setExpanded(false); return; }
    setCommentsLoading(true);
    try {
      const res = await api.get(`/admin/comments/?post_id=${post.id}`);
      setComments(res.data.comments);
      setExpanded(true);
    } finally { setCommentsLoading(false); }
  };

  const saveCaption = () => {
    onEditCaption(post.id, captionVal);
    setEditingCaption(false);
  };

  const saveComment = async (cid) => {
    await onEditComment(cid, editCommentVal);
    setComments(prev => prev.map(c => c.id === cid ? { ...c, content: editCommentVal } : c));
    setEditCommentId(null);
  };

  const removeComment = async (cid) => {
    await onDeleteComment(cid);
    setComments(prev => prev.filter(c => c.id !== cid));
  };

  const isVideo = post.media_type?.startsWith('video/');
  const mediaUrl = post.media_url ? resolveUrl(post.media_url) : null;

  return (
    <div style={S.card}>
      {/* Media */}
      {mediaUrl && (
        <div style={S.cardMedia}>
          {isVideo ? (
            <video src={mediaUrl} style={S.mediaEl} controls muted />
          ) : (
            <img src={mediaUrl} alt="post" style={S.mediaEl} onError={e => e.target.style.display = 'none'} />
          )}
          <div style={S.mediaOverlay}>
            <span style={S.mediaBadge}>{post.post_type === 'reel' ? '🎬 Reel' : '📸 Post'}</span>
          </div>
        </div>
      )}

      {/* Info */}
      <div style={S.cardBody}>
        <div style={S.cardHdr}>
          <div>
            <div style={{ fontWeight: 600, color: '#818cf8', fontSize: 11 }}>@{post.author_username}</div>
            <div style={{ fontSize: 10, color: '#475569' }}>{new Date(post.created_at).toLocaleDateString()}</div>
          </div>
          <div style={{ display: 'flex', gap: 4 }}>
            {post.is_deleted && <span style={{ fontSize: 10, color: '#f43f5e', fontWeight: 700 }}>DELETED</span>}
            <button style={S.iconBtn} onClick={() => setEditingCaption(true)} title="Edit caption">✏️</button>
            <button style={S.dangerIconBtn} onClick={() => onDelete(post)} title="Delete post">🗑️</button>
          </div>
        </div>

        {editingCaption ? (
          <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
            <textarea style={S.captionInput} value={captionVal} onChange={e => setCaptionVal(e.target.value)} rows={2} />
            <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
              <button style={S.saveBtn} onClick={saveCaption}>✓</button>
              <button style={S.cancelBtn} onClick={() => { setEditingCaption(false); setCaptionVal(post.caption); }}>✕</button>
            </div>
          </div>
        ) : (
          <p style={S.caption}>{post.caption || <em style={{ color: '#334155' }}>No caption</em>}</p>
        )}

        <div style={S.stats}>
          <span>❤️ {post.like_count}</span>
          <span>👁️ {post.view_count}</span>
          <button style={S.commentToggle} onClick={loadComments}>
            {commentsLoading ? '...' : `💬 ${post.comment_count} comments ${expanded ? '▲' : '▼'}`}
          </button>
        </div>

        {/* Machine Stats Insights */}
        <div style={{ marginTop: 10, padding: 8, background: 'rgba(99,102,241,0.05)', borderRadius: 8, fontSize: 10 }}>
            <div style={{ fontWeight: 600, color: '#818cf8', marginBottom: 4 }}>🤖 Machine Added Stats</div>
            <div style={{ display: 'flex', gap: 12 }}>
                <span>Likes: <strong>{post.machine_likes}</strong></span>
                <span>Views: <strong>{post.machine_views}</strong></span>
            </div>
            <div style={{ fontWeight: 600, color: '#34d399', marginTop: 4, marginBottom: 4 }}>👤 Real Stats</div>
            <div style={{ display: 'flex', gap: 12 }}>
                <span>Likes: <strong>{post.real_likes}</strong></span>
                <span>Views: <strong>{post.real_views}</strong></span>
            </div>
        </div>

        {/* Comments */}
        {expanded && (
          <div style={S.commentList}>
            {comments.length === 0 ? (
              <div style={{ color: '#475569', fontSize: 10, padding: '8px 0' }}>No comments</div>
            ) : comments.map(c => (
              <div key={c.id} style={{ ...S.commentRow, opacity: c.is_deleted ? 0.4 : 1 }}>
                <div style={{ flex: 1 }}>
                  <span style={{ fontWeight: 600, color: '#818cf8', fontSize: 10 }}>@{c.author_username}</span>
                  {editCommentId === c.id ? (
                    <div style={{ display: 'flex', gap: 6, marginTop: 4 }}>
                      <input style={S.commentInput} value={editCommentVal} onChange={e => setEditCommentVal(e.target.value)} />
                      <button style={S.saveSmall} onClick={() => saveComment(c.id)}>✓</button>
                      <button style={S.cancelSmall} onClick={() => setEditCommentId(null)}>✕</button>
                    </div>
                  ) : (
                    <span style={{ color: '#94a3b8', fontSize: 10, marginLeft: 8 }}>{c.content}</span>
                  )}
                  {c.parent_id && <span style={{ fontSize: 10, color: '#475569', marginLeft: 8 }}>↩ reply</span>}
                </div>
                <div style={{ display: 'flex', gap: 4, flexShrink: 0 }}>
                  <button style={S.miniEdit} onClick={() => { setEditCommentId(c.id); setEditCommentVal(c.content); }}>✏️</button>
                  <button style={S.miniDel} onClick={() => removeComment(c.id)}>🗑️</button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default function AdminPosts() {
  const [posts, setPosts] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [typeFilter, setTypeFilter] = useState('');
  const [loading, setLoading] = useState(true);
  const [confirmDelete, setConfirmDelete] = useState(null);
  const [viewMode, setViewMode] = useState('grid');

  const fetchPosts = useCallback(async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams({ page, page_size: 24, search });
      if (typeFilter) params.append('type', typeFilter);
      const res = await api.get(`/admin/posts/?${params}`);
      setPosts(res.data.posts);
      setTotal(res.data.total);
    } finally { setLoading(false); }
  }, [page, search, typeFilter]);

  useEffect(() => { fetchPosts(); }, [fetchPosts]);

  const deletePost = async (post) => {
    try {
      await api.delete(`/admin/posts/${post.id}/`);
      setPosts(prev => prev.filter(p => p.id !== post.id));
      setConfirmDelete(null);
    } catch { alert('Delete failed'); }
  };

  const editCaption = async (postId, caption) => {
    try {
      await api.put(`/admin/posts/${postId}/`, { caption });
      setPosts(prev => prev.map(p => p.id === postId ? { ...p, caption } : p));
    } catch { alert('Save failed'); }
  };

  const deleteComment = async (cid) => {
    try { await api.delete(`/admin/comments/${cid}/`); } catch { alert('Delete failed'); }
  };

  const editComment = async (cid, content) => {
    try { await api.put(`/admin/comments/${cid}/`, { content }); } catch { alert('Save failed'); }
  };

  const totalPages = Math.ceil(total / 24);

  return (
    <div style={S.root}>
      <div style={S.header}>
        <div>
          <h1 style={S.title}>📸 Posts & Comments</h1>
          <p style={S.subtitle}>{total} posts total</p>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          {['', 'post', 'reel'].map(t => (
            <button key={t} style={{ ...S.filterBtn, ...(typeFilter === t ? S.filterActive : {}) }} onClick={() => { setTypeFilter(t); setPage(1); }}>
              {t === '' ? 'All' : t === 'post' ? '📸 Posts' : '🎬 Reels'}
            </button>
          ))}
        </div>
      </div>

      <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
        <input
          style={S.searchInput}
          placeholder="Search by username or caption..."
          value={search}
          onChange={e => { setSearch(e.target.value); setPage(1); }}
        />
        <div style={{ display: 'flex', gap: 6 }}>
          <button style={{ ...S.viewBtn, ...(viewMode === 'grid' ? S.viewActive : {}) }} onClick={() => setViewMode('grid')}>⊞ Grid</button>
          <button style={{ ...S.viewBtn, ...(viewMode === 'list' ? S.viewActive : {}) }} onClick={() => setViewMode('list')}>☰ List</button>
        </div>
      </div>

      {loading ? (
        <div style={S.center}><div style={S.spinner} /></div>
      ) : posts.length === 0 ? (
        <div style={S.center}><p style={{ color: '#475569' }}>No posts found</p></div>
      ) : (
        <div style={viewMode === 'grid' ? S.grid : S.list}>
          {posts.map(post => (
            <PostCard
              key={post.id}
              post={post}
              onDelete={setConfirmDelete}
              onEditCaption={editCaption}
              onDeleteComment={deleteComment}
              onEditComment={editComment}
            />
          ))}
        </div>
      )}

      {totalPages > 1 && (
        <div style={S.pagination}>
          <button style={S.pageBtn} disabled={page === 1} onClick={() => setPage(p => p - 1)}>← Prev</button>
          <span style={{ color: '#64748b', fontSize: 11 }}>Page {page} / {totalPages}</span>
          <button style={S.pageBtn} disabled={page === totalPages} onClick={() => setPage(p => p + 1)}>Next →</button>
        </div>
      )}

      {/* Confirm delete */}
      {confirmDelete && (
        <div style={S.modalOverlay} onClick={() => setConfirmDelete(null)}>
          <div style={{ ...S.modal, maxWidth: 360 }} onClick={e => e.stopPropagation()}>
            <div style={S.modalHdr}>
              <span style={{ fontWeight: 700, color: '#f43f5e' }}>⚠️ Delete Post?</span>
              <button style={S.closeBtn} onClick={() => setConfirmDelete(null)}>✕</button>
            </div>
            <div style={{ padding: 20 }}>
              <p style={{ color: '#94a3b8', margin: '0 0 16px', fontSize: 12 }}>
                Permanently delete post by <strong style={{ color: '#e2e8f0' }}>{confirmDelete.author_username}</strong>? Media file will also be removed.
              </p>
              <div style={{ display: 'flex', gap: 10 }}>
                <button style={S.cancelBtnFull} onClick={() => setConfirmDelete(null)}>Cancel</button>
                <button style={S.dangerBtnFull} onClick={() => deletePost(confirmDelete)}>🗑️ Delete</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const S = {
  root: { flex: 1, overflowY: 'auto', padding: 24, background: '#07070d', display: 'flex', flexDirection: 'column', gap: 16, animation: 'fadeIn 0.3s ease' },
  header: { display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 },
  title: { margin: 0, fontSize: 20, fontWeight: 800, color: '#e2e8f0' },
  subtitle: { margin: '4px 0 0', color: '#475569', fontSize: 11 },
  filterBtn: { padding: '6px 14px', borderRadius: 8, border: '1px solid rgba(255,255,255,0.08)', background: 'transparent', color: '#64748b', cursor: 'pointer', fontWeight: 600, fontSize: 11 },
  filterActive: { background: 'rgba(99,102,241,0.15)', color: '#818cf8', borderColor: 'rgba(99,102,241,0.3)' },
  searchInput: { padding: '10px 16px', borderRadius: 10, border: '1px solid rgba(255,255,255,0.08)', background: 'rgba(255,255,255,0.04)', color: '#e2e8f0', fontSize: 12, outline: 'none', flex: 1, minWidth: 200, boxSizing: 'border-box' },
  viewBtn: { padding: '7px 14px', borderRadius: 8, border: '1px solid rgba(255,255,255,0.08)', background: 'transparent', color: '#64748b', cursor: 'pointer', fontSize: 11, fontWeight: 600 },
  viewActive: { background: 'rgba(99,102,241,0.15)', color: '#818cf8', borderColor: 'rgba(99,102,241,0.25)' },
  center: { display: 'flex', alignItems: 'center', justifyContent: 'center', height: 200 },
  spinner: { width: 28, height: 28, border: '3px solid rgba(99,102,241,0.2)', borderTopColor: '#6366f1', borderRadius: '50%', animation: 'spin 0.8s linear infinite' },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 14 },
  list: { display: 'flex', flexDirection: 'column', gap: 14 },
  card: { background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 14, overflow: 'hidden' },
  cardMedia: { position: 'relative', background: '#000', maxHeight: 220, overflow: 'hidden' },
  mediaEl: { width: '100%', maxHeight: 220, objectFit: 'cover', display: 'block' },
  mediaOverlay: { position: 'absolute', top: 8, left: 8 },
  mediaBadge: { background: 'rgba(0,0,0,0.6)', color: '#e2e8f0', fontSize: 10, padding: '3px 8px', borderRadius: 8, fontWeight: 600 },
  cardBody: { padding: 14 },
  cardHdr: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 },
  iconBtn: { background: 'rgba(99,102,241,0.12)', border: 'none', borderRadius: 7, padding: '5px 8px', cursor: 'pointer', fontSize: 11 },
  dangerIconBtn: { background: 'rgba(244,63,94,0.1)', border: 'none', borderRadius: 7, padding: '5px 8px', cursor: 'pointer', fontSize: 11 },
  caption: { margin: '0 0 8px', color: '#94a3b8', fontSize: 11, lineHeight: 1.5 },
  captionInput: { flex: 1, padding: '6px 10px', borderRadius: 8, border: '1px solid rgba(255,255,255,0.08)', background: 'rgba(255,255,255,0.04)', color: '#e2e8f0', fontSize: 11, outline: 'none', fontFamily: 'inherit', resize: 'none', width: '100%' },
  saveBtn: { background: 'rgba(16,185,129,0.2)', border: '1px solid rgba(16,185,129,0.3)', color: '#34d399', borderRadius: 6, padding: '4px 8px', cursor: 'pointer', fontSize: 12 },
  cancelBtn: { background: 'rgba(244,63,94,0.1)', border: '1px solid rgba(244,63,94,0.2)', color: '#f43f5e', borderRadius: 6, padding: '4px 8px', cursor: 'pointer', fontSize: 12 },
  stats: { display: 'flex', alignItems: 'center', gap: 12, fontSize: 10, color: '#475569' },
  commentToggle: { background: 'none', border: 'none', color: '#818cf8', cursor: 'pointer', fontSize: 10, padding: 0, fontWeight: 600 },
  commentList: { marginTop: 10, display: 'flex', flexDirection: 'column', gap: 6, borderTop: '1px solid rgba(255,255,255,0.05)', paddingTop: 10 },
  commentRow: { display: 'flex', alignItems: 'center', gap: 8, background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.04)', borderRadius: 8, padding: '6px 10px' },
  commentInput: { flex: 1, padding: '4px 8px', borderRadius: 6, border: '1px solid rgba(255,255,255,0.08)', background: 'rgba(255,255,255,0.04)', color: '#e2e8f0', fontSize: 10, outline: 'none' },
  saveSmall: { background: 'rgba(16,185,129,0.2)', border: 'none', color: '#34d399', borderRadius: 5, padding: '4px 8px', cursor: 'pointer', fontSize: 11 },
  cancelSmall: { background: 'rgba(244,63,94,0.1)', border: 'none', color: '#f43f5e', borderRadius: 5, padding: '4px 8px', cursor: 'pointer', fontSize: 11 },
  miniEdit: { background: 'none', border: 'none', cursor: 'pointer', fontSize: 10, padding: '2px', opacity: 0.7 },
  miniDel: { background: 'none', border: 'none', cursor: 'pointer', fontSize: 10, padding: '2px', opacity: 0.7 },
  pagination: { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 16 },
  pageBtn: { padding: '7px 16px', borderRadius: 8, border: '1px solid rgba(255,255,255,0.08)', background: 'rgba(255,255,255,0.04)', color: '#94a3b8', cursor: 'pointer', fontSize: 11 },
  modalOverlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.8)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 },
  modal: { background: '#111118', border: '1px solid rgba(255,255,255,0.09)', borderRadius: 20, width: '100%' },
  modalHdr: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '18px 20px', borderBottom: '1px solid rgba(255,255,255,0.07)' },
  closeBtn: { background: 'none', border: 'none', color: '#64748b', cursor: 'pointer', fontSize: 18 },
  dangerBtnFull: { flex: 1, padding: '10px', borderRadius: 10, border: '1px solid rgba(244,63,94,0.25)', background: 'rgba(244,63,94,0.12)', color: '#f43f5e', fontWeight: 700, cursor: 'pointer', fontSize: 12 },
  cancelBtnFull: { flex: 1, padding: '10px', borderRadius: 10, border: '1px solid rgba(255,255,255,0.08)', background: 'transparent', color: '#94a3b8', cursor: 'pointer', fontSize: 12, fontWeight: 600 },
};
